import axios from 'axios'
import store from '@/store/store'

axios.defaults.headers.post['Content-Type'] = 'application/json'
const client = axios.create({ headers: { 'Content-Type': 'application/json' } })
const ApiService = {

  async postAsync (proxyPath: any, uri: any, data: any, auths?: any) {
    const response = await axios.post(uri, data, { headers: this.getHeaders(), auth: auths, baseURL: proxyPath })
    return response.data
  },

  async putAsync (proxyPath: any, uri: any, data: any, auths?: any) {
    const response = await axios.put(uri, data, { headers: this.getHeaders(), auth: auths, baseURL: proxyPath })
    return response.data
  },
  async postAsyncTicket (proxyPath: any, uri: any, data: any, auths?: any) {
    try {
      const response: any = await axios.post(uri, data, { headers: this.getTicketHeaders(), auth: auths, baseURL: proxyPath })
      return response.data
    } catch (error) {
      this.postLogAsync(error.response)
      throw (error)
    }
  },
  async getAsync (proxyPath: any, uri: any) {
    try {
      const response: any = await axios.get(uri, { headers: this.getHeaders(), baseURL: proxyPath })
      return response.data
    } catch (error) {
      this.postLogAsync(error.response)
      throw (error)
    }
  },

  getTicketHeaders () {
    return {
      AGID: store.getToken(),
      OS: 'Web'
      // DeviceId: 'test'
    }
  },
  getHeaders () {
    return {
      AGID: store.getToken(),
      OS: 'Web',
      AppName: 'Join'
    }
  },

  async postAsyncLog (proxyPath: any, uri: any, data: any, auths?: any) {
    axios.post(uri, data, { headers: this.getHeaders(), auth: auths, baseURL: proxyPath })
  },
  postLogAsync (error: any) {
    axios.post('Log',
      {
        Level: 'Error',
        OS: 'Web',
        Message: `Failed at ${error.request.responseURL} with status code: ${error.status} - Error message: ${error.message}`
      },
      { headers: this.getHeaders(), baseURL: '/broadcastv1/' })
  }
}

export default ApiService
